<template>
	<div class="text">
		<head-com></head-com>
		<div class="center">
			<div class="header">
				<img class="l logo" src="../../assets/img/fangzi.jpg" />
				<ul class="l">
					<li class="l">
						<router-link to="home">首页</router-link>
					</li>
					<li class="l"> > </li>
					<li class="l">
						<router-link to="integral">积分商城</router-link>
					</li>
					<li class="l"> > </li>
					<li class="l">
						<router-link to="">玫瑰花边黄玛瑙吊坠</router-link>
					</li>
				</ul>
			</div>
			<div class="top">
				<div class="left l">
					<div class="up l"><img src="../../assets/img/injiazi.jpg" /></div>
					<div class="down l">
						<span class="l"><i class="el-icon-caret-left"></i></span>
						<ul class="l">
							<li class="l" v-for="(li,index) in lis" :key="index"><img :src="li" /></li>
						</ul>
						<span class="r"><i class="el-icon-caret-right"></i></span>
					</div>
				</div>
				<div class="central l">
					<p class="jieshao">北宋汝窑三足洗汝窑瓷 北宋汝窑大盘 高76.5cm 宽70cm 厚22cm</p>
					<p class="guanggao">304不锈钢内胆+不锈钢机头，双层防烫机身，爱心豆浆，暖心爱人</p>
					<div class="price">
						<p class="l">原 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;价<span>￥320.00</span></p>
						<p class="l">所需积分<span> ￥279.00</span></p>
					</div>
					<div class="dizhi">
						<p>颜 &nbsp;&nbsp;色<span>32G</span><span>128G</span><span>256G</span></p>
						<p>配送至<input type="text" /><span>运费：￥10.00</span></p>
						<p>服 &nbsp;&nbsp;务<span class="fuwu">由<span class="yellow">美玉美翡翠店</span>负责发货，并提供售后服务</span>
						</p>
					</div>
					<div class="leiji">
						<p>累计评价<span>0人评价</span></p>
						<p>累计销量<span>111</span></p>
					</div>
					<div class="shuliang">
						<span class="l">数量</span>
						<div class="inp l">
							<input class="l" type="text" v-model="value" />
							<span class="r jia"><i @click="add" class="el-icon-plus"></i></span>
							<span class="r"><i @click="lose" class="el-icon-minus"></i></span>
						</div>
						<span class="l">件 库存14件</span>
					</div>
					<div class="buy">我要兑换</div>
				</div>
				<div class="r right">
					<div class="same">商城提供</div>
					<p>礼品编号：0001</p>
					<p>添加时间：2016-11-08</p>
					<p>浏览人次：219</p>
					<div class="same">兑换记录</div>
					<ul>
						<li v-for="(item,index) in jilus" :key="index">
							<div class="l"><img :src="item.img" /></div>
							<div class="l">{{item.phone}}</div>
							<div class="l">{{item.day}} 兑换了{{item.count}}件</div>
						</li>
					</ul>
				</div>
			</div>
			<div class="bottom">
				<div class="left l">
					<div class="up">
						<p class="rmen">热门兑换</p>
						<ul class="l">
							<li class="l" v-for="(img,index) in imgs" :key="index"><img :src="img.shitou" />
								<p>{{img.p}}</p>
								<p class="l">{{img.pic}}积分</p>
							</li>
						</ul>
					</div>
					<div class="down">
						<p class="liulan">最近浏览</p>
						<ul class="liulan">
							<li class="l" v-for="(item,index) in liulan" :key="index"><img :src="item.picture" />
								<p class="l p">{{item.p}}</p><span class="l">{{item.pic}}</span></li>
						</ul>
					</div>
				</div>
				<div class="right r">
					<div class="top">
						<ul class="l">
							<li class="bg">商品介绍</li>
						</ul>
						<p class="r"></p>
					</div>
					<div class="middle">
						<p>商家货号：96004746</p>
						<p>品牌：</p>
						<p>类别：不限</p>
						<p>材料：不限</p>
						<p>工艺：不限</p>
						<p>窑口：不限</p>
					</div>
					<div class="down"><img v-for="(img,index) in down" :key="index" class="l" :src="img" /></div>
				</div>
			</div>
			<div class="base">
				<div class="top">
					<span class="l border">猜您喜欢</span>
					<span class="r">换一批</span>
					<img class="r" src="../../assets/img/huanyipi.jpg" />
				</div>
				<div class="bottom ">
					<ul>
						<li v-for="(bases,index) in basebox" :key="index">
							<img :src="bases.baijian" />
							<p>{{bases.p}}</p>
							<p>￥{{bases.pic}}</p>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<foot-com></foot-com>
	</div>
</template>

<script>
	import xiaojiazi from '@/assets/img/xiaojiazi.jpg'
	import img from '@/assets/img/jilutouxiang.png'
	import shitou from '@/assets/img/shitou.jpg'
	import bigfozhu from '@/assets/img/bigfozhu.jpg'
	import bigfozhu1 from '@/assets/img/bigfozhu1.jpg'
	import picture from '@/assets/img/xiaoxiaochahu.jpg'
	import baijian from '@/assets/img/baijian.jpg'
	export default {
		data() {
			return {
				lis: [xiaojiazi, xiaojiazi, xiaojiazi, xiaojiazi, xiaojiazi],
				value: 1,
				jilus: [{
						img: img,
						phone: '1234***',
						day: '2017-02-10',
						count: '1'
					}, {
						img: img,
						phone: '1234***',
						day: '2017-02-10',
						count: '1'
					},
					{
						img: img,
						phone: '1234***',
						day: '2017-02-10',
						count: '1'
					}, {
						img: img,
						phone: '1234***',
						day: '2017-02-10',
						count: '1'
					}
				],
				imgs: [{
						shitou: shitou,
						p: '{{this.$constant.mainTitle}}正宗纯天然野生山龟甲手串黄金甲18mm',
						pic: '500'
					}, {
						shitou: shitou,
						p: '{{this.$constant.mainTitle}}正宗纯天然野生山龟甲手串黄金甲18mm',
						pic: '500'
					},
					{
						shitou: shitou,
						p: '{{this.$constant.mainTitle}}正宗纯天然野生山龟甲手串黄金甲18mm',
						pic: '500'
					}, {
						shitou: shitou,
						p: '{{this.$constant.mainTitle}}正宗纯天然野生山龟甲手串黄金甲18mm',
						pic: '500'
					}, {
						shitou: shitou,
						p: '{{this.$constant.mainTitle}}正宗纯天然野生山龟甲手串黄金甲18mm',
						pic: '500'
					}
				],
				down: [bigfozhu, bigfozhu1, bigfozhu, bigfozhu1],
				liulan: [{
					picture: picture,
					p: '极品朱泥盖杯，名家寅 思亭壶 朱泥 宜兴  ',
					pic: '￥720.00'
				}, {
					picture: picture,
					p: '极品朱泥盖杯，名家寅 思亭壶 朱泥 宜兴  ',
					pic: '￥720.00'
				}],
				basebox: [{
						baijian: baijian,
						p: '天然A货翡翠 高档精雕墨翠自在观音28.51g',
						pic: '500.00',
						much: '971'
					}, {
						baijian: baijian,
						p: '天然A货翡翠 高档精雕墨翠自在观音28.51g',
						pic: '500.00',
						much: '971'
					},
					{
						baijian: baijian,
						p: '天然A货翡翠 高档精雕墨翠自在观音28.51g',
						pic: '500.00',
						much: '971'
					}, {
						baijian: baijian,
						p: '天然A货翡翠 高档精雕墨翠自在观音28.51g',
						pic: '500.00',
						much: '971'
					},
					{
						baijian: baijian,
						p: '天然A货翡翠 高档精雕墨翠自在观音28.51g',
						pic: '500.00',
						much: '971'
					}, {
						baijian: baijian,
						p: '天然A货翡翠 高档精雕墨翠自在观音28.51g',
						pic: '500.00',
						much: '971'
					}
				]
			}
		},
		methods: {
			add() {
				this.value++
			},
			lose() {
				if (this.value == 0) {
					this.value = 0
				} else {
					this.value--
				}
			}
		}
	
	}
</script>


<style lang="less" scoped>
	.l {
		float: left;
	}
	
	.r {
		float: right;
	}
	
	.center {
		width: 1200px;
		margin: 0 auto;
		height: 100%;
	}
	
	.header {
		height: 37px;
		line-height: 37px;
		.logo {
			padding: 13px 8px 0 0;
		}
		li {
			font-size: 12px;
			a {
				color: #a1a1a1;
			}
			&:hover a {
				color: red;
			}
		}
		li:last-child {
			a {
				color: #555;
			}
		}
	}
	
	.top {
		margin-top: 2px;
		overflow: hidden;
		.left {
			width: 400px;
			.up {
				width: 400px;
				height: 400;
				img {
					float: left;
				}
			}
			.down {
				width: 100%;
				margin-top: 14px;
				span {
					width: 15px;
					height: 52px;
					border: 1px solid #dcdcdc;
					text-align: center;
					line-height: 52px;
					margin-top: 4px;
					i {
						color: #dcdcdc;
					}
				}
				ul {
					margin: 0 9px;
					li {
						width: 58px;
						height: 58px;
						border: 1px solid #d1d1d1;
						margin-right: 15px;
						&:hover {
							border-color: #a89b4c;
						}
					}
					li:last-child {
						margin-right: 0;
					}
				}
			}
		}
		.central {
			width: 549px;
			margin-left: 10px;
			.jieshao {
				font-size: 14px;
				color: #303030;
				margin: 0 0 8px 9px;
			}
			.guanggao {
				font-size: 12px;
				color: #afa04b;
				margin: 0 0 9px 9px;
			}
			.price {
				width: 100%;
				height: 92px;
				background: url(../../assets/img/beijing.jpg) no-repeat center;
				p {
					font-size: 12px;
					color: #9a9a9a;
					margin-left: 25px;
					width: 100%;
				}
				p:nth-of-type(1) {
					margin-top: 21px;
					span {
						margin-left: 14px;
						font-size: 9px;
						color: #575757;
						text-decoration: line-through;
					}
				}
				p:nth-of-type(2) {
					margin-top: 18px;
					span {
						font-size: 18px;
						color: #d62b3e;
						margin-left: 10px;
					}
				}
			}
			.dizhi {
				overflow: hidden;
				p {
					font-size: 12px;
					color: #9a9a9a;
					margin-left: 25px;
					width: 100%;
				}
				p:nth-of-type(1) {
					height: 34px;
					line-height: 34px;
					margin-top: 20px;
					span {
						padding: 12px 14px;
						border: 1px solid #c6c6c6;
						margin-left: 11px;
						&:hover {
							border-color: #ae984d;
						}
					}
					span:nth-of-type(1) {
						margin-left: 22px;
					}
				}
				p:nth-of-type(2) {
					margin-top: 16px;
					input {
						width: 98px;
						height: 22px;
						border: 1px solid #d2d2d2;
						margin: 0 16px 0 20px;
					}
					span {
						color: #555;
					}
				}
				p:nth-of-type(3) {
					margin-top: 24px;
					.fuwu {
						margin-left: 22px;
						.yellow {
							color: #d19e29;
						}
					}
				}
			}
			.leiji {
				height: 40px;
				border-top: 1px solid #f1f1f1;
				border-bottom: 1px solid #f1f1f1;
				margin-left: 20px;
				margin-top: 22px;
				p {
					float: left;
					width: 168px;
					height: 20px;
					line-height: 20px;
					line-height: 20px;
					text-align: center;
					border-left: 1px solid #e4e0dd;
					margin-top: 10px;
					font-size: 12px;
					color: #555;
					span {
						color: #b7a661;
						margin-left: 7px;
					}
				}
				p:first-child {
					border-left: 0;
				}
			}
			.shuliang {
				margin-top: 13px;
				margin-left: 26px;
				overflow: hidden;
				span {
					font-size: 12px;
					color: #a6a6a6;
					line-height: 32px;
				}
				.inp {
					width: 80px;
					height: 30px;
					border: 1px solid #a7a7a7;
					margin: 0 9px 0 30px;
					input {
						width: 63px;
						height: 100%;
						border-right: 1px solid #a7a7a7;
					}
					span {
						width: 15px;
						height: 14px;
						background: #eef4f2;
						i {
							font-size: 7px;
							float: left;
							margin-top: 1px;
							margin-left: 2px;
							cursor: pointer;
							&:hover {
								color: red;
							}
						}
					}
					.jia {
						border-bottom: 1px solid #a7a7a7;
					}
				}
			}
			.buy {
				cursor: pointer;
				margin-top: 34px;
				width: 162px;
				height: 40px;
				text-align: center;
				line-height: 40px;
				color: #fff;
				background: #d19e29;
				border-radius: 3px;
				margin-left: 73px;
			}
		}
		.right {
			width: 210px;
			height: 474px;
			border: 1px solid #d2d2d2;
			.same {
				height: 40px;
				background: #f9f9f9;
				font-size: 14px;
				color: #333;
				padding-left: 14px;
				line-height: 40px;
			}
			P {
				color: #666;
				font-size: 12px;
				margin-left: 17px;
				margin-top: 15px;
			}
			p:nth-of-type(1) {
				margin-top: 24px;
			}
			p:nth-of-type(3) {
				margin-bottom: 21px;
			}
			ul {
				li {
					width: 192px;
					height: 60px;
					border-bottom: 1px dashed #e6e6e6;
					margin-left: 8px;
					div:nth-of-type(1) {
						width: 40px;
						height: 40px;
						border-radius: 50px;
						margin-top: 9px;
						margin-right: 9px;
					}
					div:nth-of-type(2) {
						font-size: 12px;
						color: #333;
						margin: 13px 0 0 0;
					}
					div:nth-of-type(3) {
						font-size: 12px;
						color: #999;
					}
				}
				li:last-child {
					border-bottom: 0;
				}
			}
		}
	}
	
	.bottom {
		overflow: hidden;
		margin-top: 30px;
		.left {
			width: 204px;
			.up {
				border: 1px solid #e5e5e5;
				overflow: hidden;
				.rmen {
					line-height: 40px;
					background: #f9f9f9;
					font-size: 14px;
					color: #555;
					padding-left: 11px;
				}
				ul {
					li {
						width: 168px;
						margin: 10px 17px 0;
						p {
							cursor: pointer;
							font-size: 12px;
							color: #363636;
						}
						p:nth-of-type(1) {
							margin: 10px 0;
							&:hover {
								color: red;
							}
						}
						p:nth-of-type(2) {
							color: #e74343;
							font-size: 14px;
						}
					}
				}
			}
			.down {
				border: 1px solid #e5e5e5;
				overflow: hidden;
				margin-top: 1284px;
				.liulan {
					line-height: 40px;
					background: #f9f9f9;
					font-size: 14px;
					color: #555;
					padding-left: 11px;
				}
				ul {
					li {
						width: 193px;
						border-bottom: 1px solid #ebe8e8;
						margin-left: 5px;
						height: 69px;
						img {
							margin: 10px 9px 0 5px;
							float: left;
						}
						.p {
							cursor: pointer;
							font-size: 12px;
							color: #555;
							width: 124px;
							line-height: 17px;
							margin-top: 10px;
							&:hover {
								color: red;
							}
						}
						span.l {
							line-height: 21px;
							font-size: 10px;
							color: #e30707;
						}
					}
				}
			}
		}
		.right {
			width: 983px;
			border: 1px solid #e7e6e6;
			border-top: 0;
			overflow: hidden;
			.top {
				height: 41px;
				li {
					width: 90px;
					line-height: 40px;
					text-align: center;
					border: 1px solid #e7e6e6;
					border-left: 0;
				}
				.bg {
					color: #d19e29;
					border-top: 1px solid #d19e29;
					background: url(../../assets/img/xiasanjiao.jpg) no-repeat top 0 left 50%;
				}
				p {
					border: 1px solid #e7e6e6;
					width: 890px;
					height: 41px;
					border-right: 0;
					border-left: 0;
				}
			}
			.middle {
				height: 93px;
				border-bottom: 1px solid #e8e8e8;
				width: 100%;
				p {
					float: left;
					margin-top: 25px;
					font-size: 12px;
					color: #5d5d5d;
				}
				p:nth-of-type(1) {
					width: 365px;
					margin-left: 16px;
				}
				p:nth-of-type(2) {
					width: 342px;
				}
				p:nth-of-type(3) {
					width: 234px;
				}
				p:nth-of-type(4) {
					width: 365px;
					margin-left: 16px;
					margin-top: 15px;
				}
				p:nth-of-type(5) {
					width: 342px;
					margin-top: 15px;
				}
				p:nth-of-type(63) {
					width: 234px;
					margin-top: 15px;
				}
			}
			.down {
				margin: 15px 0 76px 16px;
				overflow: hidden;
			}
		}
	}
	
	.base {
		overflow: hidden;
		margin-bottom: 40px;
		margin-top: 300px;
		.top {
			height: 39px;
			width: 100%;
			line-height: 37px;
			span.l {
				width: 105px;
				line-height: 37px;
				color: #454545;
				text-align: center;
			}
			img {
				margin: 12px 6px 0 0;
			}
			span.r {
				color: #93919e;
				font-size: 12px;
			}
			.border {
				border-bottom: 2px solid #b99e66;
				color: #ba9635 !important;
			}
		}
		.bottom {
			height: 270px;
			width: 100%;
			margin-top: 0;
			border: 1px solid #e5e5e5;
			ul {
				li {
					width: 168px;
					margin: 17px 15px 0;
					float: left;
					img {
						width: 100%;
						height: 178px;
					}
					p {
						font-size: 12px;
						margin-top: 10px;
					}
					p:nth-of-type(2) {
						color: #b22e2c;
						margin-top: 5px;
					}
				}
			}
		}
	}
</style>